import { ACTION } from '@cvent/react-analytics';

export const openSurveyPanel = {
  id: 'open_survey_panel',
  name: 'Open Survey Panel',
  type: ACTION,
  attributes: ['sessionId', 'surveyBadgeVisible'],
  destinations: ['Mixpanel', 'Analytics']
};

export const takeSurveyClicked = {
  id: 'take_survey_clicked',
  name: 'Take Survey',
  type: ACTION,
  attributes: ['sessionId', 'surveyOpenedFromToast'],
  destinations: ['Mixpanel', 'Analytics']
};
